import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import ApplicationScreen from 'screens/Application'
import LeaseCreationScreen from 'screens/LeaseCreation'
import AuthScreen from 'screens/Auth'
import BuildiumScreen from 'screens/Buildium'
import { CashoutDetails } from 'screens/Cashouts/Detail'
import { Cashouts } from 'screens/Cashouts/List'
import CapabilitiesScreen from 'screens/Capabilities'
import Collections from 'screens/Collections'
import PayOrQuitPostingPage from 'screens/Collections/PayOrQuitPostingPage'
import EvictionsScreen from 'screens/Evictions'
import CustomerProfile from 'screens/CustomerProfile'
import DashboardsScreen from 'screens/Resources/Dashboards'
import DocumentsManager from 'screens/Resources/DocumentsManager'
import HomeProfile from 'components/Homes/HomeProfile'
import HomesGridPage from 'screens/Homes'
import InitialReviewScreen from 'screens/InitialReview'
import LeadGroupsScreen from 'screens/Dispatch/LeadGroups'
import LineageScreen from 'screens/Lineage'
import ManualFMVUploader from 'screens/Fmv/ManualFmvUpload'
import RetiredProjectsRedirect from './RetiredProjectsRedirect'
import RetiredConstructionRedirect from './RetiredConstructionRedirect'
import Dispositions from 'screens/Construction/Dispositions'
import ConstructionRoute from './ConstructionRoute'
import RentalApplications from 'screens/RentalApplications'
import RenewalManager from 'screens/RenewalManager'
import RentRollBulkLiabilitiesScreen from 'screens/RentRoll/BulkLiabilities'
import RentRollDetailsScreen from 'screens/RentRoll/Details'
import RentRollScreen from 'screens/RentRoll'
import RouteConnectedAuth from 'components/Routes/ConnectedAuth'
import ShortUrlsScreen from 'screens/ShortUrls'
import StatementsBulkJournalEntryUploader from 'screens/Statements/BulkJournalEntryUploader'
import StatementsMortgageTransformer from 'screens/Statements/MortgageTransformer'
import StatementsShipStatements from 'screens/Statements/ShipStatements'
import TasksScreen from 'screens/Tasks'
import UserIncomeEditor from 'screens/UserIncome/Editor'
import UsersCreateScreen from 'screens/Users/Create'
import UsersSearchScreen from 'screens/Users/Search'
import VacancyReadiness from 'screens/VacancyReadiness'

export const ConstructionRoutes = () => (
  <Switch>
    <ConstructionRoute exact path='/construction/dispositions' component={Dispositions} />
    <Route exact path='/construction/tickets' component={RetiredConstructionRedirect} />
    <Route exact path='/construction/vendors' component={RetiredConstructionRedirect} />
    <Route exact path='/construction/vendors/:vendorId' component={RetiredConstructionRedirect} />
    <Route exact path='/construction/home-systems' component={RetiredConstructionRedirect} />
    <Route
      exact
      path='/construction/latchel-sync-manager'
      component={RetiredConstructionRedirect}
    />
    <Route
      exact
      path='/construction/occupancy_inspections'
      component={RetiredConstructionRedirect}
    />
    <Route exact path='/construction/projects' component={RetiredProjectsRedirect} />
    <Route
      exact
      path='/construction/projects/:constructionProjectId'
      component={RetiredProjectsRedirect}
    />
    <Redirect to='/homes' />
  </Switch>
)

const Routes = () => (
  <Switch>
    <Route exact path='/applications' component={RentalApplications} />
    <RouteConnectedAuth exact path='/applications/create-lease' component={LeaseCreationScreen} />
    <RouteConnectedAuth exact path='/applications/:applicationId' component={ApplicationScreen} />
    <Route exact path='/auth' component={AuthScreen} />
    <RouteConnectedAuth exact path='/buildium' component={BuildiumScreen} />
    <RouteConnectedAuth exact path='/capabilities' component={CapabilitiesScreen} />
    <RouteConnectedAuth exact path='/collections' component={Collections} />
    <RouteConnectedAuth
      exact
      path='/collections/pay-or-quit-posting'
      component={PayOrQuitPostingPage}
    />
    <Route
      exact
      path='/collections/pay-or-quit-archive'
      render={({ location }) => (
        <Redirect to={`/collections/pay-or-quit-posting${location.search}`} />
      )}
    />
    <RouteConnectedAuth exact path='/evictions' component={EvictionsScreen} />
    <RouteConnectedAuth path='/construction' component={ConstructionRoutes} />
    <RouteConnectedAuth exact path='/dashboards' component={DashboardsScreen} />
    <RouteConnectedAuth exact path='/dispatch-lead-groups' component={LeadGroupsScreen} />
    <RouteConnectedAuth path='/documents' component={DocumentsManager} />
    <RouteConnectedAuth exact path='/home/:propertyId' component={HomeProfile} />
    <RouteConnectedAuth exact path='/homes' component={HomesGridPage} />
    <RouteConnectedAuth exact path='/vacancy-readiness' component={VacancyReadiness} />
    <RouteConnectedAuth path='/lineage' component={LineageScreen} />
    <RouteConnectedAuth exact path='/properties/renewal-manager' component={RenewalManager} />
    <RouteConnectedAuth exact path='/rent-roll' component={RentRollScreen} />
    <RouteConnectedAuth
      exact
      path='/rent-roll/bulk-liabilities'
      component={RentRollBulkLiabilitiesScreen}
    />
    <RouteConnectedAuth exact path='/rent-roll/cashouts' component={Cashouts} />
    <RouteConnectedAuth exact path='/rent-roll/:rentalId' component={RentRollDetailsScreen} />
    <RouteConnectedAuth exact path='/rent-roll/:rentalId/cashout' component={CashoutDetails} />
    <RouteConnectedAuth exact path='/review' component={TasksScreen} />
    <RouteConnectedAuth
      exact
      path='/review/initial/:mlsListingId'
      component={InitialReviewScreen}
    />
    <RouteConnectedAuth exact path='/short-urls' component={ShortUrlsScreen} />
    <RouteConnectedAuth
      exact
      path='/statements/bulk-je-uploader'
      component={StatementsBulkJournalEntryUploader}
    />
    <RouteConnectedAuth exact path='/statements/fmv' component={ManualFMVUploader} />
    <RouteConnectedAuth
      exact
      path='/statements/mortgage-transformer'
      component={StatementsMortgageTransformer}
    />
    <RouteConnectedAuth exact path='/statements/ship' component={StatementsShipStatements} />
    <Route exact path='/statements/send-test' render={() => <Redirect to='/statements/ship' />} />
    <Route
      exact
      path='/statements/backup-and-rebuild'
      render={() => <Redirect to='/statements/ship' />}
    />
    <RouteConnectedAuth exact path='/users' component={UsersSearchScreen} />
    <RouteConnectedAuth exact path='/users/create' component={UsersCreateScreen} />
    <RouteConnectedAuth exact path='/users/:userId' component={CustomerProfile} />
    <RouteConnectedAuth
      exact
      path='/users/:userId/user-income-editor'
      component={UserIncomeEditor}
    />
    <Redirect to='/homes' />
  </Switch>
)

export default Routes
